<template>
    <div>
        <div class="row">
            <div class="col-sm-1">
                <v-card class="drawer-bar mx-auto" width="100%" height="100vh"
                    style="position: fixed;background: #f8f8fb !important; width: 250px !important;">
                    <v-navigation-drawer permanent style="z-index: 5;position: fixed;">
                        <Sidebar :itemsMenu="itemsMenu" />
                    </v-navigation-drawer>
                    <NavBar @updateNavBar="updateNavBar"
                        style="position: fixed;z-index: 0;width: 100%;height: 4rem !important;width: 296px !important;" />
                </v-card>
            </div>
            <v-navigation-drawer v-model="drawerBar" absolute temporary @input="updateDrawerState"
                style="padding-top: 5rem;background: #f8f8fb !important;">
                <Sidebar :itemsMenu="itemsMenu" />
            </v-navigation-drawer>
            <div class="main-responsive main-responsive--gerencia"
                style="width: 100%; padding-right: 0; margin-top: 3rem;">
                <router-view></router-view>
            </div>
            <v-overlay :z-index="zIndex" :value="overlay">
                <v-card elevation="2" shaped class="mx-auto my-5 elevation-1">
                    <v-row class="fill-height">
                        <v-col>Usuario Inhabilitado</v-col>
                    </v-row>
                </v-card>
            </v-overlay>
        </div>
    </div>
</template>

<style scoped>
::v-deep .v-icon.notranslate.fas.fa-chevron-down.theme--light {
    font-size: 0.9rem !important;
}

::v-deep .svg-inline--fa.fa-chevron-down.notranslate.theme--light.v-icon {
    font-size: 0.9rem !important;
}

.v-navigation-drawer {
    width: 280px !important;
    box-shadow: 0px 10px 45px rgba(0, 0, 0, 0.618);
}

.v-icon.v-icon,
.theme--light.v-icon {
    color: rgb(255, 255, 255) !important;
}

a {
    text-decoration: none;
}

.v-divider.theme--light {
    border-color: rgba(255, 255, 255, 0.643);
}

a:hover,
.v-list-item-navbar:hover,
.v-list-group__header :hover {
    background-color: #ffffff10;
}

.v-list-item__title.text-h6,
.v-list-item__subtitle,
.v-list-group {
    color: white !important;
    text-decoration: none;
}

.v-list-item-navbar {
    margin: 0.5rem 0;
}

.v-navigation-drawer {
    background: linear-gradient(135deg, #005dbe, #0062be, #005dc6) !important;
    color: white !important;
}

.main-responsive {
    padding-left: 22rem;
}

.main-responsive--gerencia {
    background: #0b1120 !important;
    padding-right: 0 !important;
}

@media (max-width: 1024px) {
    .main-responsive {
        margin-left: 0rem;
        padding-left: 1.5rem;
    }

    .drawer-bar {
        display: none;
    }
}

@media (min-width: 1024px) {
    .drawer-bar {
        display: block;
    }
}
</style>

<script>
import NavBar from '../../../components/navbar/NavBar.vue'
import Sidebar from '../../../components/sidebar/sidebar.vue'
import { mapState, mapActions } from 'vuex'
import axios from 'axios'

export const RUTA_API = process.env.VUE_APP_API

export default {
    components: { NavBar, Sidebar },
    data() {
        return {
            overlay: false,
            zIndex: 99,
            itemsMenu: [],
            idUsuario: null,
            system: 'Gerencia',
            idSystem: null
        }
    },
    computed: {
        ...mapState(['drawerBar']),
    },
    created() {
        this.idUsuario = sessionStorage.getItem('idUsuario')
        this.$router.afterEach(() => {
            this.setDrawerBar(false)
        })
    },
    mounted() {
        this.getIdSytem()
    },
    methods: {
        ...mapActions(['setDrawerBar']),
        updateNavBar(datos) {
            this.setDrawerBar(datos)
        },
        updateDrawerState(value) {
            this.setDrawerBar(value)
        },
        getIdSytem() {
            axios.get(RUTA_API + '/seguridad_system/obtener-id/?system=' + this.system)
                .then((res) => {
                    this.idSystem = res.data[0].id
                    sessionStorage.setItem('idSystem', this.idSystem)
                    this.loadComponentes()
                })
                .catch(() => {})
        },
        loadComponentes() {
            axios.get(RUTA_API + '/seguridad_usuario/buscar-usuario/?usuario=' + this.idUsuario + '&system=' + this.idSystem)
                .then((res) => {
                    if (res.data.estado === false) {
                        this.overlay = true
                        return
                    }
                    const lista = res.data[0].componentes
                    this.itemsMenu = this.estructurarComponentes(lista)
                })
                .catch(() => {})
        },
        estructurarComponentes(lista) {
            const mapa = {}
            const resultado = []
            lista.forEach(item => { mapa[item.id] = { ...item, children: [] } })
            lista.forEach(item => {
                if (item.padre_id === 0) {
                    resultado.push(mapa[item.id])
                } else if (mapa[item.padre_id]) {
                    mapa[item.padre_id].children.push(mapa[item.id])
                }
            })
            resultado.forEach(item => {
                if (!item.children.length) delete item.children
            })
            return resultado
        },
    },
}
</script>
